import { useState } from "react";

/**
 * A simple form state hook.
 *
 * Example usage:
 *   const { values, setField, reset } = useForm({ name: "", description: "" });
 *   // Update only the "name" field:
 *   setField("name", "Pizza");
 *   // Reset all fields back to initialValues:
 *   reset();
 */
export function useForm(initialValues) {
  const [values, setValues] = useState(initialValues);

  function setField(name, value) {
    setValues(prev => ({
      ...prev,
      [name]: value
    }));
  }

  function reset(newValues = initialValues) {
    setValues(newValues);
  }

  return { values, setField, reset };
}